import { ReactNode } from "react";

import { Skeleton } from "@/components/_atoms/skeleton";

import { usePreLoader } from "../hooks/use-preloader";
import { usePreLoaderNonBlocking } from "../hooks/use-preloader-non-blocking";

interface PreLoaderProps {
  workspaceId: string;
  userId: string;
  children: ReactNode;
}

const skeletonLight = "bg-slate-900/5";

const PreLoaderSkeleton = () => (
  <div className="flex h-full min-h-screen w-full flex-row overflow-hidden bg-canvas text-foreground">
    <div className="hidden w-[240px] shrink-0 flex-col gap-4 p-4 md:flex">
      <Skeleton className={`h-8 w-full ${skeletonLight}`} />
      <div className="flex flex-col gap-2">
        <Skeleton className={`h-7 w-3/4 ${skeletonLight}`} />
        <Skeleton className={`h-7 w-5/6 ${skeletonLight}`} />
        <Skeleton className={`h-7 w-2/3 ${skeletonLight}`} />
        <Skeleton className={`h-7 w-3/4 ${skeletonLight}`} />
        <Skeleton className={`h-7 w-1/2 ${skeletonLight}`} />
      </div>
    </div>
    <div className="relative m-0 flex min-w-0 shrink grow basis-0 flex-col bg-background">
      <div className="mx-10 mt-8 flex flex-col gap-4">
        <Skeleton className={`h-8 w-64 ${skeletonLight}`} />
        <Skeleton className={`h-4 w-96 ${skeletonLight}`} />
        <div className="my-4 w-full border-t border-solid" />
        <div className="space-y-3">
          <Skeleton className={`h-10 w-full ${skeletonLight}`} />
          <Skeleton className={`h-10 w-full ${skeletonLight}`} />
          <Skeleton className={`h-10 w-full ${skeletonLight}`} />
          <Skeleton className={`h-10 w-full ${skeletonLight}`} />
          <Skeleton className={`h-10 w-full ${skeletonLight}`} />
        </div>
      </div>
    </div>
  </div>
);

export const PreLoader = ({ workspaceId, userId, children }: PreLoaderProps) => {
  const { loading } = usePreLoader({ workspaceId, userId });

  void usePreLoaderNonBlocking({ workspaceId });

  if (loading) {
    return <PreLoaderSkeleton />;
  }

  return <>{children}</>;
};
